import { action } from 'typesafe-actions'
import { AlertTypes } from './types'
import { IAxiosResponse, IPaginator } from '../root.types'
import { Alert } from '../../application/models/alert/alert'

export const resetCreate = () => action(AlertTypes.RESET_CREATE)

// actions de captura de alertas de um determinado dia
export const loadAlertRequest = (startDate: string, endDate: string, paginator: IPaginator) =>
 action(AlertTypes.LOAD_ALERT_REQUEST, { startDate, endDate, paginator })

export const loadAlertSuccess = (response: IAxiosResponse<Alert[]>) => action(AlertTypes.LOAD_ALERT_SUCCESS, response)

export const loadAlertFailure = () => action(AlertTypes.LOAD_ALERT_FAILURE)

// actions que procura um dado de alerta
export const findAlertRequest = (alertId: string) => action(AlertTypes.FIND_ALERT_REQUEST, { alertId })

export const findAlertSuccess = (response: IAxiosResponse<Alert>) => action(AlertTypes.FIND_ALERT_SUCCESS, response)

export const findAlertFailure = () => action(AlertTypes.FIND_ALERT_FAILURE)

/* Actions para atualizar um alerta existente*/
export const updateAlertRequest = (alert: Alert) => action(AlertTypes.UPDATE_ALERT_REQUEST, { alert })

export const updateAlertSuccess = (response: IAxiosResponse<Alert>) => action(AlertTypes.UPDATE_ALERT_SUCCESS, response)

export const updateAlertFailure = () => action(AlertTypes.UPDATE_ALERT_FAILURE)
